import Lines from '../components/common/Lines';
import ProgressScroll from '../components/common/ProgressScroll';
import Cursor from '../components/common/cusor';
import LoadingScreen from '../components/common/loader';
import Navbar from '../components/common/Navbar';
import { Helmet } from 'react-helmet';
import WOW from 'wowjs';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useGSAP } from '@gsap/react';
import { useEffect, useState, useRef } from 'react';
import { auth } from '../config/firebase';
import { signInWithPopup, GoogleAuthProvider, createUserWithEmailAndPassword, sendEmailVerification } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import googleLogo from '../assets/images/logo/google.png';

gsap.registerPlugin(useGSAP, ScrollTrigger);

export default function SignIn() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isEmailLoading, setIsEmailLoading] = useState(false);
  const [isGoogleLoading, setIsGoogleLoading] = useState(false);
  const [error, setError] = useState(null);
  const [verificationSent, setVerificationSent] = useState(false);
  const [isVerified, setIsVerified] = useState(false);
  const navigate = useNavigate();
  const helloTextRef = useRef(null);
  const whiteDivRef = useRef(null);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      if (WOW && WOW.WOW) {
        const wow = new WOW.WOW({
          animateClass: 'animated',
          offset: 100,
        });
        wow.init();
      }
    }
  }, []);

  const handleGoogleSignIn = async () => {
    try {
      setIsGoogleLoading(true);
      setError(null);
      const provider = new GoogleAuthProvider();
      const result = await signInWithPopup(auth, provider);
      localStorage.setItem('isAuthenticated', 'true');
      navigate('/brands');
    } catch (error) {
      console.error('Google sign in error:', error);
      setError(error.message);
    } finally {
      setIsGoogleLoading(false);
    }
  };

  const handleEmailSignUp = async (e) => {
    e.preventDefault();
    try {
      setIsEmailLoading(true);
      setError(null);
      
      // Create user with email and password
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      
      // Send verification email
      await sendEmailVerification(userCredential.user);
      
      setVerificationSent(true);
      localStorage.setItem('isAuthenticated', 'true');
    } catch (error) {
      console.error('Email sign up error:', error);
      setError(error.message);
    } finally {
      setIsEmailLoading(false);
    }
  };

  return (
    <>
      <Helmet>
        <title>Sign In - NarrativeOS</title>
        <link rel="icon" href="/assets/imgs/favicon.ico" />
        <link rel="shortcut icon" href="/assets/imgs/favicon.ico" />
        <link rel="stylesheet" type="text/css" href="/assets/css/plugins.css" />
        <link rel="stylesheet" type="text/css" href="/assets/css/style.css" />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://fonts.googleapis.com/css?family=Poppins:100,200,300,400,500,600,700,800,900&display=swap"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@200;300;400;500;600;700&display=swap"
        />
      </Helmet>
      
      <LoadingScreen />
      <Cursor />
      <ProgressScroll />
      <Lines />
      <Navbar />
      <div id="smooth-wrapper">
        <div id="smooth-content">
          <main className="main-bg o-hidden">
            <div style={{
              minHeight: '90vh',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '20px'
            }}>
              <div style={{
                width: '440px',
                height: 'auto',
                backgroundColor: '#121212',
                borderRadius: '15px',
                padding: '30px',
                boxShadow: '0 10px 30px rgba(0,0,0,0.3)',
                border: '1px solid rgba(255,255,255,0.1)'
              }}>
                <h1 
                  ref={helloTextRef}
                  style={{
                    color: '#fff',
                    fontSize: '2.5rem',
                    fontWeight: 'bold',
                    marginBottom: '30px',
                    textAlign: 'center'
                  }}
                >
                  One Step Away
                </h1>

                <div
                  ref={whiteDivRef}
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '20px',
                    width: '100%'
                  }}
                >
                  {!verificationSent ? (
                    <>
                      <input
                        type="email"
                        placeholder="Enter your email address"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                        style={{
                          padding: '12px 15px',
                          borderRadius: '8px',
                          border: '1px solid rgba(255,255,255,0.1)',
                          fontSize: '14px',
                          outline: 'none',
                          transition: 'border-color 0.3s ease',
                          width: '100%',
                          boxSizing: 'border-box',
                          backgroundColor: '#0f0f0f',
                          color: '#fff'
                        }}
                      />
                      <input
                        type="password"
                        placeholder="Enter strong password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                        minLength="8"
                        style={{
                          padding: '12px 15px',
                          borderRadius: '8px',
                          border: '1px solid rgba(255,255,255,0.1)',
                          fontSize: '14px',
                          outline: 'none',
                          transition: 'border-color 0.3s ease',
                          width: '100%',
                          boxSizing: 'border-box',
                          backgroundColor: '#0f0f0f',
                          color: '#fff'
                        }}
                      />
                      
                      <button
                        onClick={handleEmailSignUp}
                        disabled={isEmailLoading || isGoogleLoading}
                        style={{
                          padding: '12px 15px',
                          borderRadius: '8px',
                          border: 'none',
                          backgroundColor: '#fd5b38',
                          color: '#fff',
                          fontSize: '14px',
                          fontWeight: '500',
                          cursor: isEmailLoading || isGoogleLoading ? 'not-allowed' : 'pointer',
                          width: '100%',
                          transition: 'all 0.3s ease',
                          marginBottom: '10px',
                          opacity: isEmailLoading || isGoogleLoading ? 0.7 : 1
                        }}
                      >
                        {isEmailLoading ? 'Signing up...' : 'Sign Up'}
                      </button>
                    </>
                  ) : (
                    <div style={{
                      textAlign: 'center',
                      padding: '20px',
                      backgroundColor: '#0f0f0f',
                      borderRadius: '8px',
                      marginBottom: '20px',
                      border: '1px solid rgba(255,255,255,0.1)'
                    }}>
                      <h3 style={{ marginBottom: '10px', color: '#fff' }}>Verification Email Sent!</h3>
                      <p style={{ color: '#c6c8c9', fontSize: '14px', lineHeight: '1.5' }}>
                        We've sent a verification email to <strong>{email}</strong>.<br />
                        Please check your inbox and click the verification link to complete your registration.
                        {isVerified && <span><br />Your email has been verified! You can now continue.</span>}
                      </p>
                    </div>
                  )}
                  
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px',
                    margin: '10px 0'
                  }}>
                    <div style={{
                      flex: 1,
                      height: '1px',
                      backgroundColor: 'rgba(255,255,255,0.1)'
                    }} />
                    <span style={{
                      color: '#c6c8c9',
                      fontSize: '14px'
                    }}>OR</span>
                    <div style={{
                      flex: 1,
                      height: '1px',
                      backgroundColor: 'rgba(255,255,255,0.1)'
                    }} />
                  </div>
                  
                  <button
                    onClick={handleGoogleSignIn}
                    disabled={isEmailLoading || isGoogleLoading}
                    style={{
                      padding: '12px 15px',
                      borderRadius: '8px',
                      border: '1px solid rgba(255,255,255,0.1)',
                      backgroundColor: '#0f0f0f',
                      color: '#fff',
                      fontSize: '14px',
                      cursor: isEmailLoading || isGoogleLoading ? 'not-allowed' : 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '10px',
                      transition: 'all 0.3s ease',
                      width: '100%',
                      opacity: isEmailLoading || isGoogleLoading ? 0.7 : 1
                    }}
                  >
                    <img 
                      src={googleLogo}
                      alt="Google"
                      style={{
                        width: '20px',
                        height: '20px'
                      }}
                    />
                    {isGoogleLoading ? 'Signing in...' : 'Sign in with Google'}
                  </button>
                  
                  {error && (
                    <div style={{
                      color: '#fd5b38',
                      fontSize: '12px',
                      marginTop: '10px',
                      textAlign: 'center'
                    }}>
                      {error}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </>
  );
} 